import service from "../service";

export default {
    //列表查询
    listIndex(params: any,data: any): Promise<any> {
        return service({
            method: "POST",
            url: "/检测原始数据/列表查询",
            params,
            data:data
        });
    },
    //id查看列表详情
    listById(params: any): Promise<any> {
        return service({
            method: "GET",
            url: "/检测原始数据/ID查询",
            params,
        });
    },
    //单条原始数据excel下载
    downloadExcel(params: { id: string }): Promise<any> {
        return service({
            method: "GET",
            url: "/检测原始数据/单条原始数据excel下载",
            params,
            responseType: 'blob'
        });
    },
    //现场照片下载
    downloadPhoto(params: { 文件名: string }): Promise<any> {
        console.log('调用现场照片下载接口，参数:', params)
        return service({
            method: "GET",
            url: "/检测原始数据/现场照片下载",
            params: {
                fileName: params.文件名
            },
            responseType: 'blob'
        });
    },
    // 检测原始数据变更ID查询
    rawDataChangeById(params: { id: string | number }): Promise<any> {
        return service({
            method: "GET",
            url: "/检测原始数据变更/ID查询",
            params
        });
    },
    // 检测原始数据变更提交
    rawDataChangeSubmit(data: any): Promise<any> {
        return service({
            method: "PUT",
            url: "/检测原始数据变更/变更",
            data
        });
    },
    // 检测原始数据变更记录列表查询
    rawDataChangeList(params: any, data: any): Promise<any> {
        return service({
            method: "POST",
            url: "/检测原始数据变更/列表查询",
            params,
            data: data
        });
    },
    // 检测原始数据变更详情查询
    rawDataChangeDetail(params: { id: string | number }): Promise<any> {
        return service({
            method: "GET",
            url: "/检测原始数据变更/变更详情查询",
            params
        });
    }
}
